var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCenterUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 1V1.01124M6 1V1.01124M10.5 1V1.01124M19.5 1.02267V1.03392M1.5 18.9888V19M6 18.9888V19M10.5 18.9888V19M19.5 19.0114V19.0227M19.5 14.5142V14.5255M19.5 10.0171V10.0283M19.5 5.51986V5.53111M1.5 14.4916V14.5028M1.5 9.99438V10.0056M1.5 5.49719V5.50843M15 1.01124V1.02249M15 19V19.0112M6 5.49719H15V14.4916H6V5.49719Z",
    stroke: "#D6AF66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 24H20.5",
    stroke: "#D6AF66",
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 5,
    width: 8,
    height: 10,
    fill: "#D6AF66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterUp);
export default __webpack_public_path__ + "static/media/center-up.881d0603498f4b8f7301eb5cf659613e.svg";
export { ForwardRef as ReactComponent };